<div class="flex flex-wrap gap-2">
  <button
    *ngFor="let tag of tags"
    type="button"
    (click)="toggleTag(tag.key)"
    [class]="['tag-pill', isSelected(tag.key) ? 'selected' : 'unselected']"
    [disabled]="disabled"
    data-test="review-tag-pill">
    {{ tag.description }}
  </button>
</div>

@if (isOtherSelected) {
  <mat-form-field class="mt-3 input__mini w-full">
    <input
      matInput
      type="text"
      [placeholder]="placeholder"
      [value]="otherReason"
      (input)="onOtherReasonChange($event.target.value)"
      [disabled]="disabled"
      data-test="other-reason-input"
      maxlength="50"
    />
    <mat-hint align="end">{{ otherReason?.length || 0 }}/50</mat-hint>
  </mat-form-field>
}
